import React, { useState, useEffect, useContext } from 'react'
import EquipmentService from '../../../../../services/api/equipment.service'
import EquipmentForm from '../equipment-form/EquipmentForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import { store } from '../../../../../context/StateProvider'

const EditEquipment = (props) => {
    const {id, inputChange} = props;
    const [formData, setFormData] = useState({})
    const [messages, setMessages] = useState({})
    const [isLoaded_form, setIsLoaded_form] = useState(false)
    const [apiResponse,setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    const onSuccess = (message) => {
        dispatch({
            type: "setLocationEquipment",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }
    useEffect(() => {
        setIsLoaded_form(false)
        EquipmentService.getEquipmentById(id)
            .then(res => {
                setFormData(res.data)
                setIsLoaded_form(true)
            })
            .catch(err => { setIsLoaded_form(true) })
    }, [])

    const submitHandler = (data) => {
        setIsLoader(true)

        if (!data?.practiceLocationRoomId || data?.practiceLocationRoomId=="")
        {
            delete data.practiceLocationRoomId
        }

        EquipmentService.editEquipment(data)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            }).finally(() => {
                setIsLoader(false)
            });
    }

    return (
        <>
            {isLoader && <DimLoader />}
            {isLoaded_form && <EquipmentForm submitHandler={submitHandler} initialData={formData} messages={messages} inputChange={inputChange} submitLabel="Update" onClose={()=>props.onClose() }/>}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </>
    )
}

export default EditEquipment